import React from "react";
import { Row, Col, Container} from "react-bootstrap";
import imgJornada from "../img/img-jornada.jpeg";

export default function () {

	return(
		<>
			<Container className=" salas-conocimiento">
        <Row>
          <Col md={6} className="salitas">
            <h3 className="salitas-subtitulo c1 ">Nivel inicial</h3>
                 <h3>Contamos con salas de 3, 4 y 5 años.</h3>
            <h3><b>Turno mañana</b></h3>
            <br></br>
            <h4>Jornada extendida opcional (12:30 a 15:30hs)</h4>
            <h1 className="sala">Propuesta con talleres dinámicos y creativos que promueven el aprendizaje, el juego y el desarrollo integral de los niños. Incluye actividades de música, arte, expresión corporal, tecnología y natación, entre otras.</h1>{" "}
            <figure className="jornada-figura">
              <img
                className="jornada-imagen"
                src={imgJornada}
                alt="Jornada extendida en el Nivel Inicial"
                loading="lazy"
                width="1599"
                height="899"
              />
            </figure>
          </Col>
          <Col md={6}>
            <div className="cuadrito">
              <h2>Campos de Conocimiento:</h2>
            </div>
            <ul>
              <li>Identidad y Convivencia</li>
              <li>Lengua y Literatura</li>
              <li>Matemática</li>
              <li>Ciencias Sociales, Ciencias Naturales y Tecnología</li>
              <li>Educación Artística: Plástica</li>
              <li>Educación Artística: Música</li>
              <li>Educación Física</li>
              <li>Educacion Cristiana</li>
              <li>Computacion</li>
              <li>Inglés</li>
            </ul>
          </Col>
        </Row>
			</Container>
		</>
	)
}